// app/my-statsig.tsx

"use client";

import { StatsigProvider, useClientAsyncInit } from "@statsig/react-bindings";
import { StatsigSessionReplayPlugin } from "@statsig/session-replay";
import { StatsigAutoCapturePlugin } from "@statsig/web-analytics";
import React from "react";

function StatsigInitializer({ children }: { children: React.ReactNode }) {
  const { client } = useClientAsyncInit(
    process.env.NEXT_PUBLIC_STATSIG_CLIENT_KEY as string,
    { userID: "a-user" },
    {
      plugins: [new StatsigAutoCapturePlugin(), new StatsigSessionReplayPlugin()]
    }
  );

  if (!client) {
    return <div data-oid="rq34zy7">Loading...</div>;
  }

  return (
    <StatsigProvider client={client} loadingComponent={<div data-oid="mp65tx8">Loading...</div>}>
      {children}
    </StatsigProvider>
  );
}

export default function MyStatsig({ children }: { children: React.ReactNode }) {
  return <StatsigInitializer>{children}</StatsigInitializer>;
}
